<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import * as signalR from '@microsoft/signalr'

export default {
  name: "App",
  data() {
    return {

      connection: null,

      inactivityTimer: null,
      inactivityTime: 1000 * 60 * 30, // 半小时（毫秒）

      msgSecond: 10, // 倒计数
      timerClose: null,

      beforeunloadTime: 0,
      gapTime: 0,
    }
  },
  computed: {
    ...mapGetters("oidc", ["oidcIsAuthenticated", "oidcIdToken"])
  },
  created() {
    // this.checkUnLoad()
    // this.startInactivityTimer()
  },
  destroyed() {
    window.removeEventListener('vuexoidc:userLoaded', this.userLoaded)
    
    // this.clearInactivityTimer()
    // window.removeEventListener('beforeunload', e => this.beforeunloadHandler(e));
    // window.removeEventListener('unload', e => this.unloadHandler(e));
  },
  methods: {
    ...mapActions("oidc", ["signOutOidc", "removeOidcUser"]),
    userLoaded: function (oidcUser) {
      // console.log('I am listening to the user loaded event in vuex-oidc')

      const userId = oidcUser.detail.profile.sub
      if (userId) {
        // HubConnection 构建器
        this.connection = new signalR.HubConnectionBuilder()
          .withUrl(`${process.env.VUE_APP_BOYUAN_CHAT}/chatHub?userId=${userId}`)
          .withAutomaticReconnect() // 断开自动重连
          .build()

        // 注册ReceiveMessage
        this.connection.on('ReceiveMessage', (user, message) => {
          console.log(user, message)
        })
        // 注册用户事件
        this.connection.on('UserEvent', (data) => {
          const info = JSON.parse(data)
          if (info.Type === 'force-logout') {
            // 弹框提示
            const h = this.$createElement
            this.$msgbox({
              title: '警告',
              showClose: false,
              closeOnClickModal: false,
              closeOnPressEscape: false,
              // message: h(ResultComp),
              message: h('div', null, [
                h(
                  'ElResult',
                  {
                    props: {
                      icon: 'error',
                      title: '账号警告',
                      subTitle: `您的账号已在其他地方登录, 该账号将在${this.msgSecond}秒后自动退出！`
                    }
                  },
                  ''
                ),
                h('div', { style: 'text-align: center' }, [
                  h(
                    'spam',
                    { attrs: { id: 'second1' }, style: 'color: #dc3545' },
                    `${this.msgSecond}秒后自动退出`
                  )
                ])
              ]),
              confirmButtonText: '立刻退出'
            }).then(() => {
              this.signOutOidc()
            })

            // 创建定时器
            this.timerClose = setInterval(() => {
              if (this.msgSecond === 1) {
                this.signOutOidc()
              }
              this.$nextTick(() => {
                this.msgSecond = this.msgSecond - 1
                document.getElementById(
                  'second1'
                ).innerHTML = `${this.msgSecond}秒后自动关闭`
              })
            }, 1000)

            // this.signOutOidc();
          }
        })

        // 开始连接
        this.connection
          .start()
          .then(() => console.log('SignalR Connection successful!'))
          .catch((err) => {
            console.log(err)
          })
      }
    },
    userSignedOut: function() {
      console.log('I am listening to the user SignedOut event in vuex-oidc')
      // if (process.env.NODE_ENV !== 'development') {
      //   this.signOutOidc()
      // }
    },

    startInactivityTimer() {
      this.clearInactivityTimer()
      this.inactivityTimer = setTimeout(() => {
        // 用户在半小时内没有操作，执行退出逻辑
        this.signOutOidc()
      }, this.inactivityTime);

      // 监听用户操作并重置定时器
      ['mousemove', 'keydown', 'scroll', 'mousewheel'].forEach((event) => {
        document.addEventListener(event, this.resetInactivityTimer)
      })
    },
    resetInactivityTimer() {
      clearTimeout(this.inactivityTimer)
      this.startInactivityTimer()
    },
    clearInactivityTimer() {
      clearTimeout(this.inactivityTimer);
      ['mousemove', 'keydown', 'scroll', 'mousewheel'].forEach((event) => {
        document.removeEventListener(event, this.resetInactivityTimer)
      })
    },

    // 检查关闭时间是否在半小时之内
    checkUnLoad() {
      const unloadTime = window.localStorage.getItem('unloadTime')
      if (unloadTime) {
        //console.log(new Date().getTime() - Number(unloadTime), 30 * 60 * 1000);
        if (new Date().getTime() - Number(unloadTime) >= this.inactivityTime) {
          this.signOutOidc()
        }
        window.localStorage.removeItem('unloadTime')
      }
    },
    beforeunloadHandler() {
      this.beforeunloadTime = new Date().getTime()
      // var confirmationMessage = '您确定要离开吗?';
      // e.returnValue = confirmationMessage;
      // return confirmationMessage;
    },
    unloadHandler() {
      //e.preventDefault(); // 阻止页面立即关闭
      this.gapTime = new Date().getTime() - this.beforeunloadTime
      //window.localStorage.setItem('timer', String(this.unloadTime - this.beforeunloadTime))
      if (this.gapTime <= 5) {
        window.localStorage.setItem('unloadTime', String(new Date().getTime()))
      }
      // if (this.unloadTime - this.beforeunloadTime <= 5) {
      //   // 执行退出登录
      //   window.localStorage.setItem('timer', String(this.unloadTime - this.beforeunloadTime))
      //   //window.localStorage.setItem('id_token', this.oidcIdToken);

      //   fetch(`https://auth.gzbytech.com/connect/endsession?id_token_hint=${this.oidcIdToken}&post_logout_redirect_uri=https://boyuanclass.test.gzbytech.com/logout`, {
      //     method: 'get',
      //     mode: 'no-cors'
      //   })
      //   .then(response => response.json())
      //   .then(data => {
      //     console.log(data);
      //   })
      //   .catch(error => {
      //     console.error('Error:', error);
      //   });
      // }
    },
  },
  mounted() {
    window.addEventListener('vuexoidc:userLoaded', this.userLoaded);
    //window.addEventListener('vuexoidc:userSignedOut', this.userSignedOut)

    // window.addEventListener('beforeunload', e => this.beforeunloadHandler(e));
    // window.addEventListener('unload', e => this.unloadHandler(e));
  }
};
</script>

<style>
/* #app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
} */

body {
  margin: 0;
  /* background: #eee; */
  height: 100%;
  /* overflow-y: scroll; */

  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
  font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Arial, sans-serif;
}

html {
  height: 100%;
  box-sizing: border-box;
}

*,
*:before,
*:after {
  box-sizing: inherit;
}

body,
div,
dl,
dt,
dd,
ul,
ol,
li,
h1,
h2,
h3,
h4,
h5,
h6,
pre,
code,
form,
fieldset,
legend,
input,
button,
textarea,
p,
blockquote,
th,
td {
  margin: 0;
  padding: 0;
}

.text-center {
  text-align: center
}

.app-container {
  margin: 0;
  padding: 0;
}
</style>
